import { Tooltip } from "@forge/common";
import { responsive } from "../../utils/helper";
import { useRef } from "react";

type PageHeaderProps = {
  title?: string;
  bold?: boolean;
  className?: string;
  tooltip?: string;
  subTooltip?: string;
};

export const PageHeader = ({ title }: PageHeaderProps) => {
  return (
    <h3
      className={`
      text-[16px] 
      xl-low:text-[16px] xl-mid:text-[23px] xl-high:text-[26px]
      font-bold leading-[34px] text-white text-center flex mb-0`}
    >
      {title}
    </h3>
  );
};

type PageSubHeaderProps = {
  title?: string;
  subheading?: string;
};

export const PageSubHeader = ({ title, subheading }: PageSubHeaderProps) => {
  return (
    <div
      className={`text-base 
        xl-low:text-base xl-mid:text-[21px] xl-high:text-[22px]
       font-semibold leading-[34px] text-white`}
    >
      {title}
      {subheading && (
        <>
          <span
            className={`text-base xl-low:text-base xl-mid:text-[21px] xl-high:text-[22px] font-normal leading-[22px]`}
          >
            &nbsp; &nbsp;| &nbsp; &nbsp;{subheading}
          </span>
        </>
      )}
    </div>
  );
};

export const TableHeaderText = ({ title }: PageHeaderProps) => {
  return (
    <div
      className={`text-xs xl-low:text-xs xl-mid:text-[19px] xl-high:text-[24px] font-extrabold leading-[22px] text-white uppercase`}
    >
      {title}
    </div>
  );
};

export const BodyText = ({
  title = "",
  bold,
  className = "",
  tooltip,
  subTooltip
}: PageHeaderProps) => {
  const fontWeight = bold ? "font-bold" : "font-normal";

  const homeRef1 = useRef<HTMLSpanElement>(null);

  const baseClasses =
    "text-xs xl-low:text-xs xl-mid:text-[18px] xl-high:text-[22px] font-normal leading-[22px] text-white";

  const textView = (
    <div className={`${baseClasses} ${fontWeight} ${className}`.trim()}>
      {title}
    </div>
  );

  if (tooltip) {
    return (
      <div className={`text-xs xl-low:text-xs xl-mid:text-[18px] xl-high:text-[22px] font-normal leading-[22px] ${fontWeight} text-white ${className}`}>
        <span ref={homeRef1}>{textView}</span>
        <Tooltip
          anchor={homeRef1}
          position="bottom"
          className="text-[#303030] text-sm  flex flex-col break-words"
        >
          <div className="flex flex-col">
            <div>{tooltip}</div>
            {subTooltip && <div>{subTooltip}</div>}
          </div>
        </Tooltip>
      </div>
    );
  }

  return textView;
};

interface defaultHeaderProps {
  title?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const NormalText = ({ title, className, style }: defaultHeaderProps) => {
  return (
    <div className={`${className}`} style={style}>
      {title}
    </div>
  );
};